import _ from 'lodash';
import React from 'react';
import { DASHBOARD_DRAWER_PROPS, DASHBOARD_DRAWER_STATE } from './Types';
import { Component } from '../../dispatcher/modules';
import BaseDrawer from './drawers/BaseDrawer';

/**
 * @class DashboardDrawer
 * Dashboard drawer implements the drawer container which requires children to be rendered
 */
export default class DashboardDrawer extends Component<DASHBOARD_DRAWER_PROPS, DASHBOARD_DRAWER_STATE> {
  constructor(props) {
    super(props);

    this.state = {
      editAction: props.editAction,
      title: _.get(props.drawerData, this.props.titleFromCell) || this.translate('title')
    };
  }

  /**
   * Sets drawer title
   * Defaults to empty string ""
   * @param title
   */
  setTitle = (title: string) => this.setState({ title });
  setAction = (editAction: string) => this.setState({ editAction });

  shouldComponentUpdate = (nextProps) => {
    if (_.get(this, 'props.editAction') !== nextProps.editAction) {
      this.setState({
        editAction: nextProps.editAction
      });
      return false;
    }
    return true;
  }

  renderBody(): any {
    let { title, editAction } = this.state;
    const { className, drawerData, drawer, onDrawerToggle } = this.props;

    return (
      <BaseDrawer
        className={className}
        title={title}
        drawerData={drawerData}
        editAction={editAction}
        onDrawerToggle={onDrawerToggle}
      >{drawer}</BaseDrawer>
    );
  }
}
